export default __webpack_public_path__ + "static/logo-region-normandie-9539bc38a8b172064682cece8f0c3166.svg";